import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
  } from "react-router-dom";
import { store } from "..";
import { landingPathFor } from "./managerRouting";


export function PrivateRoute({ component: Component, authed, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) =>
          
          authed === true ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{ pathname: "/sign-in", state: { from: props.location } }}
            />
          )
        }
      />
    );
  }
  export function AuthedRoute({ component: Component, authed, ...rest }) {
    const currentUser = store.getState().auth?.user;

    // Chemin email/mot de passe : SignIn ne redirige pas lui-même, c'est ici que
    // l'utilisateur authentifié est envoyé vers sa destination. Un CP manager va
    // dans son espace, les autres gardent le comportement existant.
    if (authed === true && currentUser?.is_company_manager === true) {
      return (
        <Route
          {...rest}
          render={(props) => (
            <Redirect
              to={{ pathname: landingPathFor(currentUser), state: { from: props.location } }}
            />
          )}
        />
      );
    }

    if (store.getState().auth?.user.new_user) {
      return (
        <Route
          {...rest}
          render={(props) =>
            authed === false ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{ pathname: "/use-wosh", state: { from: props.location } }}
              />
            )
          }
        />
      );
    }
     else {
      return (
        <Route
          {...rest}
          render={(props) =>
            authed === false ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{ pathname:  store.getState().auth?.homeAddress?.length > 0 || store.getState().auth?.officeAddress?.length > 0 ? "/home" :"/use-wosh", state: { from: props.location } }}
              />
              
            )
          }
        />
      );
    }
  }